import { FC, useState } from 'react'
import { Column, VerticalCenteredRow } from '../../core/Components'
import { MediaTypes, titleCase } from '../../core/Utils'
import { gray9 } from '../../platform/color'
import { Tab } from '../../platform/explore/common/Tabs'
import CurrentlyPlayingSampleInfo from './CurrentlyPlayingSampleInfo'
import CurrentlyPlayingSongInfo from './CurrentlyPlayingSongInfo'
import CurrentlyPlayingStemInfo from './CurrentlyPlayingStemInfo'

export const ProfileCurrentlyPlayingTabs = {
  OVERVIEW: '0',
  PROPERTIES: '1'
}

export interface CurrentlyPlayingMediaInfo {
  tab: string
  index: string
}

interface InfoRowProps {
  title: string
  children: JSX.Element | JSX.Element[] | string | number | any
  tight?: boolean
}
export const InfoRow: FC<InfoRowProps> = ({ title, children, tight }) => (
  <VerticalCenteredRow
    css={{
      justifyContent: 'space-between',
      fontSize: '12px',
      padding: !tight && '12px 0px',
      paddingBottom: tight && '15px',
      fontWeight: '500'
    }}
  >
    <VerticalCenteredRow
      css={{
        flex: '1',
        color: '#000000',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {title}
    </VerticalCenteredRow>
    <VerticalCenteredRow
      css={{
        flex: '1',
        textAlign: 'right',
        color: gray9,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {children}
    </VerticalCenteredRow>
  </VerticalCenteredRow>
)

interface CurrentlyPlayingInfoProps {
  playerType: string // possible values = ProfileRoutes.SUBTYPE
  index: number
}
const CurrentlyPlayingInfo: FC<CurrentlyPlayingInfoProps> = ({ playerType, index }) => {
  const [currentlySelectedTab, setCurrentlySelectedTab] = useState(
    ProfileCurrentlyPlayingTabs.OVERVIEW
  )
  const indexStr = index.toString()

  const onClickOverview = () => setCurrentlySelectedTab(ProfileCurrentlyPlayingTabs.OVERVIEW)
  const onClickProperties = () => setCurrentlySelectedTab(ProfileCurrentlyPlayingTabs.PROPERTIES)

  return (
    <Column>
      <VerticalCenteredRow css={{ borderBottom: '1px solid #D6D6D6' }}>
        <Tab
          onClick={onClickOverview}
          active={currentlySelectedTab === ProfileCurrentlyPlayingTabs.OVERVIEW}
        >
          Overview
        </Tab>
        <Tab
          onClick={onClickProperties}
          active={currentlySelectedTab === ProfileCurrentlyPlayingTabs.PROPERTIES}
        >
          {titleCase(playerType)} properties
        </Tab>
      </VerticalCenteredRow>
      {playerType === MediaTypes.SONGS && (
        <CurrentlyPlayingSongInfo index={indexStr} tab={currentlySelectedTab} />
      )}
      {playerType === MediaTypes.STEMS && (
        <CurrentlyPlayingStemInfo index={indexStr} tab={currentlySelectedTab} />
      )}
      {playerType === MediaTypes.SAMPLES && (
        <CurrentlyPlayingSampleInfo index={indexStr} tab={currentlySelectedTab} />
      )}
    </Column>
  )
}

export default CurrentlyPlayingInfo
